// dashboardReducer.js
import {
  GET_JOB_FEEDBACK_REQUEST,
  GET_JOB_FEEDBACK_SUCCESS,
  GET_JOB_FEEDBACK_FAILURE,
} from "../../actionTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  // is_daily_visit: 0,
};

const getJobFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB_FEEDBACK_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_JOB_FEEDBACK_SUCCESS:
      console.log("gggggg", action.payload);
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        // is_daily_visit: action.payload.data.is_daily_visit,
        error: null,
      };
    case GET_JOB_FEEDBACK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default getJobFeedbackReducer;
